import React from 'react'
import { connect } from 'react-redux'

const _ViewApartmentPage = (props) => {
    let levelStr = props.match.params.aptLevel;
    let apartment = props.match.params.number.replace('-', '.');
    let selectedApartment = props.blob.levels[levelStr].apartments[apartment];
    console.log(selectedApartment);

    return (
        <div>
            <div className="ispi-breadcrumbs">
                <a href="/apartments">apartments</a>&nbsp;>&nbsp;<a href={`/apartments/level/${levelStr}`}>level {levelStr}</a>&nbsp;>&nbsp;<span>apartment {apartment}</span>
            </div>
            <div className="ispi-apartment-image-container">
                <img src={selectedApartment.floorplan} alt=""/>
                <div className="ispi-apartment-abs-label font-mb fontsize-lg">apartment type {selectedApartment.type !== "" ? selectedApartment.type.replace("-", " - ") : selectedApartment.apartment}</div>
            </div>
            <div className="ispi-apartment-stats-bar colour-bg-lg font-ml fontsize-lg">
                { selectedApartment.study !== 0 ? `${selectedApartment.bed} BED / ${selectedApartment.bath} BATH / STUDY` : `${selectedApartment.bed} BED / ${selectedApartment.bath} BATH` }
            </div>
            <div className="colour-bg-lg ispi-apartment-footer-header">
                LEVELS {selectedApartment.type !== "" ? selectedApartment.type.replace("-", " - ").replace(/\.[0-9]+/g, "") : selectedApartment.apartment}
            </div>
            <div className="ispi-apartment-footer-bar-container">
                <div className="ispi-apartment-footer-plate-container ispi-visible-desktop-mobile">
                    <img src={selectedApartment.location} alt="" />
                </div>

                <div className="ispi-apartment-footer-details-container">
                    <div className="ispi-apartment-footer-details-right">
                        <div className="ispi-visible-tablet-mobile">
                            <div className="pos-rel ispi-apartment-footer-values-container">
                                <span className="font-mb fontsize-med ispi-apartment-footer-details-label">internal area</span><span className="font-ml fontsize-med ispi-apartment-footer-details-value">{selectedApartment.internal}m2</span>
                            </div>
                            <div className="pos-rel ispi-apartment-footer-values-container">
                                <span className="font-mb fontsize-med ispi-apartment-footer-details-label">terrace area</span><span className="font-ml fontsize-med ispi-apartment-footer-details-value">{selectedApartment.terrace}m2</span>
                            </div>
                            <div className="pos-rel ispi-apartment-footer-values-container">
                                <span className="font-mb fontsize-med ispi-apartment-footer-details-label">total area</span><span className="font-ml fontsize-med ispi-apartment-footer-details-value">{selectedApartment.total}m2</span>
                            </div>
                        </div>
                        <div className="ispi-apartment-footer-plate-container ispi-visible-tablet" style={{ marginTop: '12px', marginBottom: '12px' }}>
                            <img src={selectedApartment.location} alt="" />
                        </div>
                        <div className="ispi-apartment-footer-key-container">
                            <span className="font-mb fontsize-sm">KEY</span><br />
                            <br />
                            <span className="font-ml fontsize-sm">F. Fridge</span><br />
                            <span className="font-ml fontsize-sm">P. Pantry</span><br />
                            <span className="font-ml fontsize-sm">L. Laundry</span><br />
                            <span className="font-ml fontsize-sm">W. Wardrobe</span><br />
                        </div>
                        <div className="ispi-apartment-footer-arrow-container">
                            <img src="https://storage.googleapis.com/fifteen85.data.insiteinteractive.com.au/images/arrow/north%20arrow.svg" alt=""/>
                        </div>
                    </div>

                    <div className="ispi-apartment-footer-details-left">
                        <div className="ispi-visible-desktop">
                            <div className="pos-rel ispi-apartment-footer-values-container">
                                <span className="font-mb fontsize-med ispi-apartment-footer-details-label">internal area</span><span className="font-ml fontsize-med ispi-apartment-footer-details-value">{selectedApartment.internal}m2</span>
                            </div>
                            <div className="pos-rel ispi-apartment-footer-values-container">
                                <span className="font-mb fontsize-med ispi-apartment-footer-details-label">terrace area</span><span className="font-ml fontsize-med ispi-apartment-footer-details-value">{selectedApartment.terrace}m2</span>
                            </div>
                            <div className="pos-rel ispi-apartment-footer-values-container">
                                <span className="font-mb fontsize-med ispi-apartment-footer-details-label">total area</span><span className="font-ml fontsize-med ispi-apartment-footer-details-value">{selectedApartment.total}m2</span>
                            </div>
                        </div>
                        <div className="ispi-apartment-footer-discdown-container">
                            <div className="ispi-footer-downloads">
                                <a className="download-pdf-btn" href={selectedApartment.floorplanPdf} target="_blank">DOWNLOAD APARTMENT {selectedApartment.type !== "" ? selectedApartment.type.replace("-", " - ") : selectedApartment.apartment}</a>
                                <a className="download-pdf-btn" href={selectedApartment.floorplatePdf} target="_blank">DOWNLOAD LEVEL PLAN</a>
                            </div>
                            <div className="disclaimer ispi-footer-disclaimer">
                                These plans are intended as a guide only. The dimensions and areas are approximate only and may not accurately represent the actual dimensions and areas of the apartments or the spaces within them and are subject to change without notice. In addition, locations of utilities may vary during construction and fittings and fixtures on these plans are for illustrative purposes only. The areas are generally measured in accordance with the Property Council of Australia method of measurement. Prospective purchasers must rely on their own enquiries and should refer to the Contract of Sale and its schedules for all matters to be included in the purchase price of the apartment, including plans, finishes, fixtures, fittings, appliances and other particulars of sale. Loose furniture and planters are not included. Extent of floor finishes may vary. External space and landscaping indicative only. Refer to level plans for further information.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

const mapStateToProps = state => {
    return {
        blob: state.data.blob
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

const ViewApartmentPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(_ViewApartmentPage);

export default ViewApartmentPage;


// WEBPACK FOOTER //
// ./src/pages/view-apartment/ViewApartmentPage.js